<template>
  <div class="main notMemberIndexMain">
    <!-- 顶部 -->
    <div class="title">
      <img class="blueCircle" src="../assets/blueCircle.png" />
      <span class="text">申请信息</span>
    </div>

    <!-- 内容主体 -->
    <el-table :data="tableData" border style="width: 99%">
      <el-table-column align="center" prop="memberno" label="会员编号"></el-table-column>
      <el-table-column width="180px" align="center" prop="companyname" label="单位名称">
        <template slot-scope="scope">
          <p @click="handleCompanyname" style="cursor:pointer;">{{scope.row.companyname}}</p>
        </template>
      </el-table-column>
      <el-table-column width="160px" align="center" prop="committeeoption" label="所属专业委员会">
        <template slot-scope="scope">
          <p v-for="(item,index) in scope.row.committeeoption" :key="index" @click="handleCommitteeoption(item.id)" style="cursor:pointer;">{{item.name}}</p>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="memberlevel" label="会员级别">
        <template slot-scope="scope">
          <p style="color: #FFaa00;">{{scope.row.memberlevel}}</p>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="qrcode" label="二维码">
        <img v-if="memberno" src="../assets/enlargement.png" @click="showQrcode" style="cursor:pointer;" />
      </el-table-column>
      <el-table-column align="center" prop="certificate" label="我的证书">
        <img v-if="memberno" src="../assets/enlargement.png" @click="showCertificate" style="cursor:pointer;" />
      </el-table-column>
      <el-table-column align="center" prop="contactpersoncontactname" label="联系人"></el-table-column>
      <el-table-column width="120px" align="center" prop="contactpersonphone" label="联系手机"></el-table-column>
      <el-table-column align="center" prop="status" label="状态"></el-table-column>
      <el-table-column width="150px" align="center" prop="enddate" label="会费有效期至"></el-table-column>
      <el-table-column align="center" prop="options">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)" v-if="status !== '0'">修改信息</el-button>
          <el-button size="mini" plain @click="handlePrint(scope.row)">打印</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="二维码" :visible="qrcodeDialogVisible" width="30%" :before-close="closeQrcodeDialog">
      <img :src="downloadUrl + qrcode" style="width: 100%;">
    </el-dialog>
    <!-- 我的证书 -->
    <el-dialog title="我的证书" :visible="certificateDialogVisible" width="55%" :before-close="closeCertificateDialog">
      <el-button type="primary" @click="downloadCertificate" class="downloadCfBtn">下载</el-button>
      <!-- 我的证书下载部分 -->
      <div ref="certificatePic">
        <img src="../assets/certificate-bg.jpg" style="width: 100%;">
        <div class="certificateText">
          <p>会员编号：{{memberno}}</p>
          <p>会员：{{companyname}}</p>
          <p>会费有效期：{{enddate}}</p>
        </div>
        <div class="certificateDate">
          <p>发证单位：<span>上海市绿色建筑协会</span></p>
          <p>发证日期：<span>{{issuedate}}</span></p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as API from '../utils/apiService'
import * as Cache from '../utils/cache'
import html2canvas from 'html2canvas'
import config from '../config'

const { downloadUrl } = config

export default {
  data () {
    return {
      downloadUrl,
      tableData: [],
      qrcodeDialogVisible: false,
      certificateDialogVisible: false,
      memberno: '',
      companyname: '',
      committeeoption: '',
      memberlevel: '',
      qrcode: '',
      certificate: '',
      contactpersoncontactname: '',
      contactpersonphone: '',
      status: '',
      enddate: '',
      options: '',
      issuedate: '',
      id: '', // 专委会id

      memberlevelMap: {
        0: '会员',
        1: '理事',
        2: '常务理事',
        3: '副会长'
      },
      statusMap: {
        0: '未处理',
        1: '已处理',
        3: '暂存'
      },
      committeeoptionMap: {
        '-24806': '规划与建筑设计专业委员会',
        '-24807': '绿色建造专业委员会',
        '-24808': '绿色住宅专业委员会',
        '-24809': '绿色建筑运行管理专业委员会',
        '-24810': '绿色建材专业委员会',
        '-24811': '绿色建筑设备设施专业委员会',
        '-24812': '节水与水资源利用专业委员会',
        '-24813': '建筑绿化专业委员会',
        '-24814': '绿色交通设施专业委员会',
        '-24815': '绿色能源和再生资源专业委员会',
        '-24818': '绿色照明专业委员会',
        '-24819': '地下空间绿色低碳专业委员会',
        '-24816': 'BIM',
        '-24817': '其他'
      }
    }
  },
  mounted () {
    this.asyncFindOneInfo()
  },
  methods: {
    asyncFindOneInfo () {
      let params = {
        userid: Cache.getUserInfo().id
      }
      API.findOneInfo(params).then(resp => {
        this.tableData = [
          {
            ...resp.data,
            memberlevel: this.memberlevelMap[resp.data.memberlevel], // 会员级别覆盖
            status: this.statusMap[resp.data.status], // 状态覆盖
            committeeoption: resp.data.committeeoption.split(',').map(id => ({
              name: this.committeeoptionMap[id],
              id
            })) // 专委会覆盖
          }
        ]
        this.id = resp.data.committeeoption.replace(',', '')
      })
    },
    handleCompanyname () {
      this.$router.push('/previewApplication')
    },
    handleCommitteeoption (id) {
      let params = {
        id
      }
      API.findByCommitteeid(params).then(resp => {
        window.open(resp.data.link)
      })
    },
    showQrcode () {
      this.qrcodeDialogVisible = true
    },
    showCertificate () {
      this.certificateDialogVisible = true
    },
    handleEdit () {
      this.$router.push('/notMemberEditApplication')
    },
    handlePrint () {
      let params = {
        userid: Cache.getUserInfo().id
      }
      API.downloadWord(params).then(resp => {
        if (resp.resultCode === '0000') {
          window.open(downloadUrl + resp.resultMsg)
        }
      })
    },
    closeQrcodeDialog () {
      this.qrcodeDialogVisible = false
    },
    closeCertificateDialog () {
      this.certificateDialogVisible = false
    },
    // 下载证书
    fileDownload (downloadURL) {
      var aLink = document.createElement('a')
      aLink.style.display = 'none'
      aLink.href = downloadURL
      aLink.download = '我的证书.png'
      // 触发点击-然后移除
      document.body.appendChild(aLink)
      aLink.click()
      document.body.removeChild(aLink)
    },
    // 将html元素转换成canvas
    downloadCertificate () {
      html2canvas(this.$refs.certificatePic).then(canvas => this.fileDownload(canvas.toDataURL()))
    }
  }
}
</script>

<style lang="scss">
.notMemberIndexMain {
  .title {
    .text {
      margin-left: 0;
      color: #3778ff;
    }
    .blueCircle {
    vertical-align: middle;
    width: 30px;
    height: 30px;
    }
  }
}
</style>
